
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.897 5.1h12.206c1.545 0 2.797 1.176 2.797 2.626v9.548c0 1.45-1.252 2.626-2.797 2.626H5.897c-1.545 0-2.797-1.176-2.797-2.626V7.726C3.1 6.276 4.352 5.1 5.897 5.1zM4.5 10v7.3c0 .663.579 1.2 1.293 1.2h12.414c.714 0 1.293-.537 1.293-1.2V10h-15zm15-1.5h-15v-.8c0-.663.579-1.2 1.293-1.2h12.414c.714 0 1.293.537 1.293 1.2v.8z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.951 11.034a.7.7 0 01.47.871l-1.5 5a.7.7 0 11-1.341-.402l1.5-5a.7.7 0 01.871-.47zm-3.206 1.175a.7.7 0 010 .99L8.74 14.204l1.005 1.005a.7.7 0 11-.99.99L7.396 14.84a.9.9 0 010-1.272l1.359-1.359a.7.7 0 01.99 0zM14.255 12.209a.7.7 0 000 .99l1.005 1.005-1.005 1.005a.7.7 0 10.99.99l1.359-1.359a.9.9 0 000-1.272l-1.36-1.359a.7.7 0 00-.989 0z"}})])
          )
        }
      }
    